// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"235":"512041ed","913":"0819f4af","1367":"c1a1f6ce","4044":"6f06643d"}[chunkId] + ".chunk.css";
};